import { useState } from "react";
import { createGroup } from "../../services/groupService";

import './CreateGroup.css';

const CreateGroupForm = ({ friends, onCreated, onClose }) => {
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [groupName, setGroupName] = useState("");

  const handleCheckboxChange = (friendId) => {
    setSelectedMembers(prev =>
      prev.includes(friendId)
        ? prev.filter(id => id !== friendId)
        : [...prev, friendId]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!groupName.trim()) {
      alert("Group name is required!");
      return;
    }

    if (selectedMembers.length < 2) {
      alert("Select at least 2 friends to create a group");
      return;
    }

    try {
      const payload = {
        name: groupName,
        members: selectedMembers
      };

      const res = await createGroup(payload);
      alert("Group created!");
      onCreated(res.data);
      onClose?.();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Failed to create group");
    }
  };

  return (
    <div className="create-group-form">
      {/* Close button */}
      <button className="close-btn" onClick={onClose}>X</button>

      <h3>Create a New Group</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Group Name</label>
          <input
            type="text"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            placeholder="Enter group name"
            required
          />
        </div>

        <div className="friends-checkbox-list">
          <p>Select Members:</p>
          {friends.map(friend => (
            <label key={friend._id} className="friend-label">
              <input
                type="checkbox"
                value={friend._id}
                checked={selectedMembers.includes(friend._id)}
                onChange={() => handleCheckboxChange(friend._id)}
              />
              {friend.username}
            </label>
          ))}
        </div>

        <button type="submit" className="btn-submit">Create Group</button>
      </form>
    </div>
  );
};

export default CreateGroupForm;
